<template>
    <div id="generator_left">
        <div class="generator_left cursor_1" @click="toHome">
            <img src="@/assets/image/icon_right.png" alt="">
            返回首页
        </div>
        <div class="generator_left1" ref="scrollContainer">
            <div class="cursor_1" v-for="(item, i) in labelList" :key="i" @click="select(i)"
                :class="labelIndex == i ? 'generator_left1_1 generator_left1_3' : 'generator_left1_1'">
                <img :src="item.iconV2" alt="">
                <div class="generator_left1_2">{{ item.name }}</div>
            </div>
        </div>
        <div class="generator_left2">
            <div class="generator_left2_1" @click="openVip">开通会员</div>
        </div>
        <vipPopup></vipPopup>
    </div>
</template>
<script>
import { EventBus } from '@/utils/eventBus';
import vipPopup from '@/components/vip_popup.vue' //vip页面
import api from '@/api/api';
export default {
    components: {
        vipPopup
    },
    data() {
        return {
            labelList: [],
            labelIndex: 0,

        }
    },
    created() {
        this.labelList = JSON.parse(sessionStorage.getItem('aiList'))
        this.labelIndex = sessionStorage.getItem('aiIndex')
        this.$nextTick(() => {
            this.scrollToSelectedLabel()
            setTimeout(() => {
                EventBus.$emit('getTemplate', this.labelList[this.labelIndex])
            }, 50)
        })

    },
    methods: {
        //返回首页
        toHome() {
            this.$router.push({ path: '/' });
        },
        //选择
        select(i) {
            this.labelIndex = i
            this.$emit('openContent', this.labelList[i], i)
        },
        openVip() {
            api.getUserinfo().then((res) => {
                if (res.code == 200) {
                    EventBus.$emit('openVip')
                } else {
                    EventBus.$emit('openLogin')
                }
            })
        },
        // 滚动到选中的标签
        scrollToSelectedLabel() {
            const scrollContainer = this.$refs.scrollContainer
            const selectedItem = scrollContainer.children[this.labelIndex]
            if (selectedItem) {
                selectedItem.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                })
            }
        }
    }
}
</script>

<style>
#generator_left {
    width: 230px;
    height: 100%;
    background-color: #FFFFFF;
    border-radius: 0 5px 5px 0;
    margin-right: 10px;
}

.generator_left {
    width: 100%;
    height: 67px;
    font-size: 17px;
    color: #000000;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #DDDDDD;
}

.generator_left img {
    width: 23px;
    height: 23px;
    margin-right: 5px;
}

.generator_left1 {
    width: 100%;
    height: calc(100% - 138px);
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    padding: 15px;
}

.generator_left2 {
    height: 69px;
    width: 100%;
    display: flex;
    font-size: 17px;
    color: #000000;
    padding: 0 30px;
    align-items: center;
    justify-content: center;
    border-top: 1px solid #DDDDDD;
}

.generator_left2_1 {
    width: 100%;
    height: 50px;
    background-image: url('@/assets/image/left_icon.png');
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 17px;
    color: #000000;
    cursor: pointer;
}

.generator_left1_1 {
    width: 200px;
    height: 50px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    margin-bottom: 15px;
}

.generator_left1_1:last-child {
    margin-bottom: 0;
}

.generator_left1_1 img {
    width: 21px;
    height: 21px;
    margin-right: 8px;
}

.generator_left1_2 {
    flex: 1;
    font-size: 16px;
    color: #111111;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.generator_left1_3 {
    background: var(--tech-btn-Lightblue);
    border-radius: 4px;
}
</style>